import { Avatar, DialogProps, IconButton, useListGraphqlQuery, useTranslationRoute, useUserProfilePicture } from "@bsm/component"
import _ from "lodash";
import { TUserStudentScholarity } from "@bsm/graphql";
import { Link } from "react-router-dom";
import { DeleteStudentDialog } from "./DeleteStudentDialog";
import { useEffect, useState } from "react";
import { useStudentDeleteMutation } from "../hooks/useStudentDeleteMutation";
import { useScholarityQuery } from "../views/details/hooks/useScholarityQuery";
import { STUDENT_LIST_ID } from "views/list/containers/StudentListContainer";
import { SCHOLARITY_LIST_ID } from "../container/ScholarityListContainer";
import { useGetStudentsQuery } from "../views/create/hooks/useGetStudentsQuery";

export const StudentsList = (props: TProps) => {

    const tr = useTranslationRoute()
    const profilePictureUrl = useUserProfilePicture()
    const [wantToDelete, setWantToDelete] = useState(false);
    const [studentId, setStudentId] = useState(0);
    const mutation = useStudentDeleteMutation();
    const { invalidateQuery: invalidateQueryScholarity } = useScholarityQuery(props?.id ? props.id : undefined, true)
    const { invalidateQuery: invalidateStudentListQuery } = useListGraphqlQuery(STUDENT_LIST_ID);
    const { invalidateQuery: invalidateScholarityListQuery } = useListGraphqlQuery(SCHOLARITY_LIST_ID);
    const { invalidateQuery } = useGetStudentsQuery({}, true)

    const handleDelete = () => {
        if (studentId) mutation.mutate({ id: studentId, scholarityId: props?.id })
    };

    useEffect(() => {
        if (mutation.isSuccess) {
            setWantToDelete(false)
            invalidateQuery()
            invalidateQueryScholarity()
            invalidateStudentListQuery()
            invalidateScholarityListQuery()
        }
    }, [mutation.isSuccess])

    return (
        <div>
            <div className="flex flex-col gap-2 mt-4 max-h-[400px] overflow-y-auto">
                {
                    props?.students?.map((student, index) => {
                        return (
                            <div key={index} className="flex items-center justify-between w-full pt-2 pb-4 border-default border-b">
                                <div className="flex items-center gap-4">
                                    <Link to={tr(`admin/students/${student?.id}`)} target="_blank">
                                        <Avatar
                                            src={profilePictureUrl(student?.user?.id)}
                                            size="md"
                                        />
                                    </Link>
                                    <Link to={tr(`admin/students/${student?.id}`)} target="_blank">
                                        <h5 className="font-semibold mb-0">{student?.user?.fullName}</h5>
                                    </Link>
                                </div>
                                <IconButton icon="fa-solid fa-times" onClick={() => { setWantToDelete(true); setStudentId(student.id) }} />
                            </div>
                        )
                    })
                }
            </div>

            <DeleteStudentDialog open={wantToDelete} onClose={() => setWantToDelete(false)} onConfirm={handleDelete} />
        </div>
    )
}

type TProps = Partial<TUserStudentScholarity> & Partial<DialogProps> & {
    onDeleteStudent?: (studentId: number) => void
}